import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function EmptyState({
  icon = 'ri-inbox-line',
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-14 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-foreground-500">
        <i className={`${icon} text-2xl`}></i>
      </span>
      <div>
        <h3 className="font-heading text-base font-semibold text-foreground-900">{title}</h3>
        {description && (
          <p className="mx-auto mt-1 max-w-md text-sm text-foreground-500">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}